import Link from 'next/link'
import { stringify } from 'querystring'
import React from 'react'

import { Button } from '@wartek-id/button'
import {
  Sheet,
  SheetBody,
  SheetCloseButton,
  SheetContent,
  SheetOverlay,
  SheetTitle,
} from '@wartek-id/sheet'
import { Text } from '@wartek-id/text'

type NeedRevisionCardProps = {
  revision: string
  topikId: string
  name: string
}

const NeedRevision = ({
  revision = '',
  name,
  topikId,
}: NeedRevisionCardProps) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const FIX_URL = `/topik/jurnal-pembelajaran/form?${stringify({
    topik_name: name,
    topik: topikId,
  })}`

  return (
    <>
      <div>
        <Button fullWidth color="white" onClick={() => setIsOpen(true)}>
          Baca saran perbaikan
        </Button>
      </div>
      <Sheet
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false)
        }}
        position="bottom"
        returnFocus
        sheetSize="auto"
        type="modal"
      >
        <SheetOverlay />
        <SheetContent className="max-w-xl m-auto">
          <SheetTitle bordered>
            <Text variant="heading-sm">Saran Perbaikan</Text>
          </SheetTitle>
          <SheetCloseButton />
          <SheetBody>
            <div className="border border-subdued rounded m-4">
              <Text className="px-4 py-5 pb-3">{revision}</Text>
              <div className="p-3">
                <Link href={FIX_URL}>
                  <Button
                    data-testid="fix-button"
                    color="black"
                    fullWidth
                    size="lg"
                  >
                    Perbaiki Jurnal
                  </Button>
                </Link>
              </div>
            </div>
          </SheetBody>
        </SheetContent>
      </Sheet>
    </>
  )
}

export default NeedRevision
